export default __webpack_public_path__ + "static/media/codepen-icon.20205c56.svg";